import { ReactElement, useCallback } from 'react';

import { useHistory } from 'react-router-dom';
import { CSSProperties } from 'styled-components';

import * as S from './styles';

interface IGoBackButtonProps {
  containerStyle?: CSSProperties;
}

function GoBackButton({ containerStyle }: IGoBackButtonProps): ReactElement {
  const router = useHistory();

  const handleGoBack = useCallback(() => {
    router.goBack();
  }, [router]);

  return (
    <S.Container style={containerStyle} onClick={handleGoBack}>
      {'<'} voltar
    </S.Container>
  );
}

GoBackButton.defaultProps = {
  containerStyle: {},
};

export default GoBackButton;
